module.exports = __webpack_public_path__ + "02_short_black.58b5c7b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer5/02_short_black.png
// module id = 7DTi
// module chunks = 0